import { render, staticRenderFns } from "./BtnLoteamentoLeilao.vue?vue&type=template&id=6997b30e&"
import script from "./BtnLoteamentoLeilao.vue?vue&type=script&lang=js&"
export * from "./BtnLoteamentoLeilao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports